import type { Resolver } from 'react-hook-form';

export type DoExtension = 'Y' | 'N';

export type DoExtensionFormValues = {
  senderEmail: string;
  value: string;
  pickupLocation: string;
  unstuffingType: string;
  requestedPartnerName: string;
  releaseType: string;
  userRemarks: string;
  previousRejectionRemarks: string;
  selectedApprovalLevel: number;
  doUploadStatus: string;
  doNumber: string;
  doExtension: DoExtension;
  doIntegrationRemarks: string;
};

export const doExtensionResolver: Resolver<DoExtensionFormValues> =
  async (values) => {
    const errors: Record<string, any> = {};

    const emailRaw = (values.senderEmail ?? '') as string;
    const email = emailRaw.trim();
    const country = (values as any).country;
    const isCountryRequired = country === 'USA' || country === 'CAN';

    // senderEmail required for USA/CAN, otherwise optional but must be a valid email if present
    if (isCountryRequired && !email) {
      errors.senderEmail = {
        type: 'required',
        message: 'Email is required',
      };
    } else if (email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        errors.senderEmail = {
          type: 'pattern',
          message: 'Email is invalid',
        };
      }
    }

    return {
      values: Object.keys(errors).length ? {} as any : values,
      errors,
    };
  };

